import { render } from "./tag_timeline.vue?vue&type=template&id=047310d3"
import script from "./tag_timeline.js?vue&type=script&lang=js"
export * from "./tag_timeline.js?vue&type=script&lang=js"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__